export default "<div class=\"preloader\">\r\n    <div class=\"loader\"></div>\r\n</div>";